import React from "react";
import { Switch } from "react-router-dom";
import { connect } from "react-redux";
import PrivateRoute from "components/common/PrivateRoute";
import ServiceTypesList from "components/menu/master-files/service-types/list";

const ServiceTypesRouter = props => (
    <div className="px-5">
        <Switch>
            <PrivateRoute
                exact
                path={`${props.match.url}/`}
                component={ServiceTypesList}
            />
        </Switch>
    </div>
);

export default connect()(ServiceTypesRouter);
